<mat-progress-spinner
    mode="indeterminate"
    [diameter]="64"
    [strokeWidth]="6"
    color="accent"
    aria-label="Carregando"
  ></mat-progress-spinner>
